import { objectWithAccessors, isFunction } from "../utils";

const Supports = objectWithAccessors({
  localStorage: __supportsLocalStorage__,
  matchMedia: __supportsMatchMedia__,
  performance: __supportsPerformance__,
  worker: __supportsWorker__
});

function __supportsLocalStorage__() {
  try {
    if ('localStorage' in self) {
      let stored;
      const storedValue = '1';
      const storageKey = `___${Date.now()}${String(Math.random() * 1e5).split('.')[1]}___`;

      localStorage.setItem(storageKey, storedValue);
      stored = localStorage.getItem(storageKey);
      localStorage.removeItem(storageKey);

      return stored === storedValue;
    }
  } catch (e) {}

  return false;
}

function __supportsMatchMedia__() {
  return 'matchMedia' in self;
}

function __supportsPerformance__() {
  return ('performance' in self) &&
    isFunction(performance.now);
}

function __supportsWorker__() {
  return 'Worker' in self;
}

export default Supports;
